"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = LocalQueryRenderer;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = require("react");

var _reactRelay = require("react-relay");

var _js = require("@adeira/js");

var _createLocalEnvironment = _interopRequireDefault(require("./createLocalEnvironment"));

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["variables"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// Please note: we are currently only wrapping this component to add it correct Flow types.
// Eventually, it can be extended with other functions like original QueryRenderer.
function LocalQueryRenderer(props) {
  var _ref2, _props$environment;

  var onLoading = props.onLoading ? props.onLoading : undefined;
  var onResponse = props.onResponse ? props.onResponse : undefined;
  var renderQueryRendererResponse = (0, _react.useCallback)(function (_ref) {
    var rendererProps = _ref.props;

    if (!rendererProps) {
      return onLoading ? onLoading() : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        "data-testid": "loading",
        children: "Loading local\u2026"
      });
    }

    !(onResponse !== undefined) ? process.env.NODE_ENV !== "production" ? (0, _js.invariant)(false, 'LocalQueryRenderer used default render function but "onResponse" property has not been provided.') : (0, _js.invariant)(false) : void 0;
    return onResponse(rendererProps);
  }, [onLoading, onResponse]); // 1) <LQR environment={Env} /> always win
  // 2) <LQR /> checks whether we provide Environment via `RelayEnvironmentProvider`
  // 3) <LQR /> defaults to the default local environment

  var context = (0, _react.useContext)(_reactRelay.ReactRelayContext);
  var environment = (_ref2 = (_props$environment = props.environment) !== null && _props$environment !== void 0 ? _props$environment : context === null || context === void 0 ? void 0 : context.environment) !== null && _ref2 !== void 0 ? _ref2 : (0, _createLocalEnvironment.default)();
  var variables = props.variables,
      rest = (0, _objectWithoutProperties2.default)(props, _excluded);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRelay.LocalQueryRenderer, _objectSpread({
    environment: environment,
    render: renderQueryRendererResponse,
    variables: variables !== null && variables !== void 0 ? variables : {}
  }, rest));
}